// extracted by mini-css-extract-plugin
module.exports = {"removeIconFromEntity":"IanosEnergy_removeIconFromEntity__3EK2e"};